import { Card, Row, Typography } from "antd";

import "../../styles/ComponentStyles/AppCard.less";

const { Title } = Typography;

const AppCard = ({ children, heading }) => {
  return (
    <Card className="card">
      <Row justify="center">
        <Title level={2}> {heading} </Title>
      </Row>
      {children}
    </Card>
  );
};

export default AppCard;
